import React, { useState, useEffect, useRef, useMemo } from "react";

import { useDispatch, useSelector } from "react-redux";
import { isMobile } from "react-device-detect";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import SendIcon from "@mui/icons-material/Send";
import Box from "@mui/material/Box";
import AttachmentIcon from "@mui/icons-material/Attachment";
import CancelIcon from "@mui/icons-material/Cancel";
import { Skeleton, TextField } from "@mui/material";
import {
  Grid,
  Tabs,
  Tab,
  Badge,
  Typography,
  Tooltip,
  IconButton
} from "@mui/material";

import SubjectSupport from "./SubjectSupport";
import MessageSupport from "./MessageSupport";
import useStyle from "./Suppot.style";
import {
  getSupportMessagesStart,
  createMessage,
  getSupportSubjectsStart,
  pusherStart,
  PusherUnsbscribe
} from "../../redux-saga/redux/support/chatsupport";
import { showErrorMessage } from "../../redux-saga/redux/toast";
import DialogModal from "./DialogModal";
import {
  ACCEPTED_IMAGE_FORMATS,
  MAX_IMAGE_FILE_SIZE_SUPPORT
} from "../../utils/constants";

const MyTickets = ({ setsupportModal }) => {
  const {
    subjectlist,
    messageloading,
    messagedetails,
    appendMessage,
    ticketStatus
  } = useSelector((state) => state.supportmodal);
  const [input, setInput] = useState("");
  const [ticketid, setTicketid] = useState("");
  const [selectedTicketId, setSelectedTicketId] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [chatData, setChatData] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [adminname, setAdminname] = useState("");
  const [chatImage, setChatImage] = useState();
  const [open, setOpen] = React.useState(false);
  const [supportImage, setSupportImage] = useState({
    selectedImage: null,
    selectedImageName: "",
    avatar: null
  });

  const rowsPerPage = 10;
  const classes = useStyle();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const lastMessageData = useMemo(
    () => chatData[chatData?.length - 1],
    [chatData]
  );
  useEffect(() => {
    dispatch(
      getSupportSubjectsStart({ currentPage, limit: isMobile ? 500 : 10 })
    );
  }, [dispatch, currentPage]);

  useEffect(() => {
    if (subjectlist?.rows?.length) {
      setTicketid(subjectlist?.rows[0]?.id);
      setSelectedTicketId(subjectlist?.rows[0]?.id);
      dispatch(pusherStart(subjectlist?.rows[0]?.id));
    }
  }, [dispatch, subjectlist]);

  useEffect(() => {
    if (messagedetails?.length) setChatData([...messagedetails]);
  }, [messagedetails]);

  let updatedData = Array.isArray(messagedetails) ? [...messagedetails] : [];

  useEffect(() => {
    if (appendMessage && appendMessage.message) {
      const newMessage = { ...appendMessage.message };
      updatedData.push(newMessage);
      setChatData([...chatData, newMessage]);
    }
  }, [appendMessage]);

  useEffect(() => {
    if (updatedData && updatedData.length > 0) {
      scrollToEnd();
      setAdminname(updatedData?.[updatedData.length - 1]?.agent_name);
    }
  }, [updatedData]);

  useEffect(() => {
    scrollToStart();
  }, [messagedetails]);

  const messageContainerRef = useRef(null);

  const handlePageChange = (action) => {
    if (action === "previous" && currentPage > 1) {
      setCurrentPage((prevPage) => prevPage - 1);
    } else if (action === "next" && currentPage < totalPages) {
      setCurrentPage((prevPage) => prevPage + 1);
    }
  };

  if (subjectlist?.count == 0) {
    dispatch(showErrorMessage({ tKey: "SUPPORT_MODAL.TICKETS_NOT_FOUND" }));
    setsupportModal(false);
  }

  const totalPages = Math.ceil(subjectlist.count / rowsPerPage);

  const handleTicket = (id) => {
    dispatch(getSupportMessagesStart(id));
    dispatch(pusherStart(id));
    setTicketid(id);
    setSelectedTicketId(subjectlist?.rows.find((row) => row.id === id)?.id);
    if (id !== subjectlist?.rows[0]?.id) {
      dispatch(PusherUnsbscribe(subjectlist?.rows[0]?.id));
    }
  };

  const resetSelectedImage = () => {
    setSupportImage({
      selectedImage: null,
      selectedImageName: "",
      avatar: null
    });
  };

  const scrollToEnd = () => {
    if (messageContainerRef?.current) {
      messageContainerRef.current.scrollTop =
        messageContainerRef?.current?.scrollHeight;
    }
  };

  const scrollToStart = () => {
    if (messageContainerRef.current) {
      messageContainerRef.current.scrollTop = 0;
    }
  };

  const handleClickOpen = (imageUrl) => {
    setChatImage(imageUrl);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const makeAvatarUrl = () => {
    if (supportImage.selectedImage) {
      return URL.createObjectURL(supportImage.selectedImage);
    }
    return "/images/user_icon.svg";
  };

  const handleInputMessage = (e) => {
    if (e.target.value !== " ") {
      setInput(e.target.value);
    }
  };

  const sendInputMessage = () => {
    const formData = new FormData();

    if (input === "" && !supportImage.selectedImage) {
      dispatch(showErrorMessage({ msg: "message is empty" }));
    } else {
      if (supportImage.selectedImage) {
        formData.append("attachment", supportImage.selectedImage);
      }
      formData.append("ticketId", ticketid);
      formData.append("message", input.trim());

      dispatch(createMessage(formData));
      setInput("");
    }
  };

  const handleFileInputChange = (event) => {
    event.preventDefault();
    const file = event.target.files && event.target.files[0];
    if (!file) {
      resetSelectedImage(event);
      return;
    }
    if (file?.size > MAX_IMAGE_FILE_SIZE_SUPPORT) {
      toast.error(t("MYPROFILE.MAX_FILE_SIZE_ERROR_2MB"), {
        id: "MAX_FILE_SIZE_ERROR"
      });
      return;
    }

    setSupportImage((current) => ({
      selectedImage: file,
      avatar: current.avatar,
      selectedImageName: file?.name || ""
    }));
  };

  return (
    <>
      {!isMobile && (
        <Grid container spacing={2}>
          <Grid item lg={4}>
            <SubjectSupport
              handleTicket={handleTicket}
              handlePageChange={handlePageChange}
              selectedTicketId={selectedTicketId}
              totalPages={totalPages}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
            />
          </Grid>
          <Grid style={{ padding: "0" }} item lg={8}>
            <MessageSupport
              ticketid={ticketid}
              input={input}
              updatedData={chatData}
              appendMessage={appendMessage}
            />
          </Grid>
        </Grid>
      )}

      {isMobile && (
        <>
          <span>
            <Tabs
              value={"1"}
              indicatorColor="none"
              variant="scrollable"
              className={classes.subjectTab}
              scrollButtons="auto"
              aria-label="Scrollable auto tabs example"
            >
              {subjectlist?.rows?.map(
                (row, index) =>
                  row?.ticket?.trim()?.length > 0 && (
                    <Tab
                      className={`${classes.listTab} ${
                        row?.id === selectedTicketId
                          ? classes.selectedSubject
                          : ""
                      }`}
                      disableRipple={true}
                      value={row?.ticket}
                      label={
                        <span className={classes.tabText}>{row?.ticket}</span>
                      }
                      key={row.id}
                      style={{
                        marginRight:
                          index !== subjectlist.rows.length - 1 ? "10px" : "0"
                      }}
                      onClick={() => handleTicket(row.id)}
                      onKeyDown={(event) => {
                        if (event.key === "Enter") {
                          handleTicket(row?.id);
                        }
                      }}
                      role="button"
                      tabIndex={0}
                    />
                  )
              )}
            </Tabs>
          </span>
          <span className={classes.subjectWrap}>
            {messagedetails?.[0]?.ticket}
            <br /> Admin: {t("SUPPORT_MODAL.CUSTOMER_SERVICE")}
          </span>
          {messageloading ? (
            <div className={classes.skeletonLoader}>
              <Skeleton
                variant="rectangular"
                height={"100%"}
                className={classes.skeletonprogress}
              />
            </div>
          ) : (
            <>
              <div className={classes.mobileMessage} ref={messageContainerRef}>
                {chatData?.map((message) => (
                  <div key={message?.id}>
                    {message?.user_name || message?.owner_type === "User" ? (
                      <>
                        <p className={classes.username1}>
                          <span className={classes.textMessageUser1}>
                            {message?.file_path && (
                              <DialogModal
                                handleClickOpen={handleClickOpen}
                                handleClose={handleClose}
                                open={open}
                                message={message}
                                chatImage={chatImage}
                              />
                            )}
                            {message?.message}
                          </span>
                        </p>
                      </>
                    ) : (
                      <>
                        <p className={classes.username2}>
                          <span className={classes.textMessageUser2}>
                            {message?.file_path && (
                              <DialogModal
                                handleClickOpen={handleClickOpen}
                                handleClose={handleClose}
                                open={open}
                                message={message}
                                chatImage={chatImage}
                              />
                            )}
                            {message?.message}
                          </span>
                        </p>
                      </>
                    )}
                  </div>
                ))}
              </div>
              {ticketStatus || lastMessageData?.ticket_status ? (
                <Typography className={classes.chatEnded}>
                  {t("SUPPORT_MODAL.CONVERSATION_ENDED_MESSAGE")}
                </Typography>
              ) : (
                <Box
                  className={`${classes.chatSendBox} ${supportImage.selectedImage ? classes.sendIconPosition : ""}`}
                >
                  <TextField
                    id="standard-basic"
                    variant="standard"
                    placeholder="Message"
                    value={input}
                    onChange={handleInputMessage}
                    onKeyDown={(event) => {
                      if (event.key === "Enter") {
                        sendInputMessage();
                        resetSelectedImage();
                      }
                    }}
                    InputProps={{
                      endAdornment: (
                        <Grid className={classes.msgInputCta}>
                          <Badge
                            className={`selected-img-badge ${
                              supportImage.selectedImage
                                ? classes.attachmentBadge
                                : ""
                            }`}
                            badgeContent={
                              supportImage.selectedImage ? (
                                <IconButton onClick={resetSelectedImage}>
                                  <CancelIcon />
                                </IconButton>
                              ) : null
                            }
                          >
                            <Tooltip
                              classes={{
                                tooltip: classes.toolTipWrap,
                                arrow: classes.toolTipArrow
                              }}
                              title={
                                supportImage.selectedImage
                                  ? t("SUPPORT_MODAL.CHANGE_IMAGE")
                                  : t("SUPPORT_MODAL.UPLOAD_IMAGE")
                              }
                              arrow
                            >
                              <IconButton
                                className={classes.textFieldEndIconBtn}
                                disabled={messageloading}
                                variant="contained"
                                component="label"
                              >
                                <input
                                  key={supportImage.selectedImageName}
                                  onChange={handleFileInputChange}
                                  type="file"
                                  hidden
                                  accept={ACCEPTED_IMAGE_FORMATS.join(",")}
                                />
                                {supportImage.selectedImage ? (
                                  <div className={classes.selectedImgWrap}>
                                    <img
                                      height="30"
                                      width="30"
                                      alt=""
                                      src={makeAvatarUrl()}
                                    />
                                    <Typography
                                      className={classes.selectedImgName}
                                    >
                                      {supportImage.selectedImageName}
                                    </Typography>
                                  </div>
                                ) : (
                                  <AttachmentIcon />
                                )}
                              </IconButton>
                            </Tooltip>
                          </Badge>
                        </Grid>
                      )
                    }}
                  />
                  <SendIcon
                    className={classes.sendIcon}
                    onClick={() => {
                      sendInputMessage();
                      resetSelectedImage();
                    }}
                    onKeyDown={(event) => {
                      if (event.key === "Enter") {
                        sendInputMessage();
                        resetSelectedImage();
                      }
                    }}
                  ></SendIcon>
                </Box>
              )}
            </>
          )}
        </>
      )}
    </>
  );
};

export default MyTickets;
